import { Link, useNavigate } from "react-router-dom";
import { LOGO_url } from "../../utils/constants";
import ShowAlert from "../Modal/ShowAlert";
import { useState } from "react";
import { toast } from "react-toastify";
import { api } from "../../services/api";

const ForgotPassword = () =>{
    const [showModal, setShowModal] = useState(false);
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

   const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!email) {
            toast.error("Please enter your email address");
            return;
        }

        setLoading(true);
        try {
            const response = await api.auth.forgotPassword({email});

            if (response.data.status === "success") {
                setShowModal(true);
            } else {
                toast.error(response.data.message || "Something went wrong.");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Error sending reset email.");
        } finally {
            setLoading(false);
        }
    };
    const closeModal = ()=>{
        setShowModal(false);
        navigate("/login");
    }
    return (
        <div className="main">
            <div className="login-container">
                <div className="logo-container">
                    <img className="logo" src={LOGO_url} alt="Logo" />
                </div>
                <div className="login-box">
                    <h2>Forgot Password</h2>
                    <p>Please enter your email address</p>
                    <form className="login-form" onSubmit={handleFormSubmit}>
                        <div className="form-group" >
                            <div className="input-icon-container">
                                <input 
                                    type="email" 
                                    id="email" 
                                    placeholder="Email Address" 
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required/>
                                <span className="input-icon">
                                    <img src="/assets/icons/email-icon.svg" alt="Email Icon" />
                                </span>
                            </div>
                        </div>
                        <button type="submit" className="btn btn-primary btn-lg btn-xl generalBtn" disabled={loading}>
                            {loading ? "Sending..." : "Reset Password"}
                        </button>
                        <div className="text-center mt-3 cancel-btn">
                            <Link to="/login">Cancel</Link>
                        </div>
                    </form>
                </div>
            </div>
            {showModal && (
                <ShowAlert 
                    showModal={showModal}
                    closeModal={closeModal}
                    title="Password Recovery"
                    icon={<img src="/assets/icons/alert.png" alt="Alert Icon" className="alert-bell" />}
                    message="A new password has been sent to your email address.Please check your inbox."
                />
            )};
        </div>
    );
};

export default ForgotPassword;